// extracted by mini-css-extract-plugin
export default {"wrap":"error-boundary_wrap__sU+Q3","button":"error-boundary_button__VNnXt"};